<template>
  <div class="text-left mb-3">
    <div class="d-flex align-items-center mb-2">
      <font-awesome-icon class="mr-2 icon-chevron" icon="chevron-right" />
      <v-label class="label-input">{{ label }}</v-label>
    </div>

    <v-combobox
      :name="name"
      :data-vv-as="(label || '').replace('*', '').trim()"
      :value="value"
      @input="$emit('input', $event)"
      v-validate="rules"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      :loading="loading"
      :disabled="disabled"
      autocomplete="off"
      outlined
      dense
    ></v-combobox>

    <span class="red--text">{{ validationErrors.first(name) }}</span>
  </div>
</template>

<script>
export default {
  name: "BaseCombobox",
  // Usa el validador del formulario que lo contiene, asi sus reglas (ej: required) bloquean el guardado
  inject: ["$validator"],
  props: {
    label: String,
    name: String,
    value: null,
    rules: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemText: {
      type: String,
      default: "text",
    },
    itemValue: {
      type: String,
      default: "value",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    validationErrors: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
